// Mock data for Community Conserved Areas website

export const communityConservedAreas = [
  {
    id: 1,
    name: "Sacred Grove of Mawphlang",
    location: "Meghalaya, India",
    coordinates: { lat: 25.4670, lng: 91.7362 },
    area: "78 hectares",
    established: "Ancient (700+ years)",
    biodiversity: "180+ plant species, medicinal herbs, endangered orchids",
    community: "Khasi tribal community",
    description: "An ancient sacred forest preserved by the Khasi indigenous community for over 700 years. The grove is home to rare medicinal plants and serves as a living museum of traditional ecological knowledge.",
    image: "https://images.unsplash.com/photo-1511497584788-876760111969?w=800&q=80",
    threats: "Tourism pressure, edge degradation",
    conservation_status: "Protected by customary law"
  },
  {
    id: 2,
    name: "Hivre Bazar Village Commons",
    location: "Maharashtra, India",
    coordinates: { lat: 19.5826, lng: 75.1924 },
    area: "294 hectares",
    established: "1989",
    biodiversity: "Restored grasslands, native tree species, seasonal wetlands",
    community: "Hivre Bazar Village Council",
    description: "A remarkable example of community-led watershed management and ecosystem restoration. The village transformed from drought-prone to water-abundant through collective action.",
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=800&q=80",
    threats: "Climate change impacts",
    conservation_status: "Community managed"
  },
  {
    id: 3,
    name: "Loma del Peligro Community Reserve",
    location: "Patagonia, Argentina",
    coordinates: { lat: -41.1335, lng: -71.3103 },
    area: "1,200 hectares",
    established: "2012",
    biodiversity: "Andean condors, guanacos, native southern beech forests",
    community: "Local ranching communities",
    description: "A community-conserved area protecting critical habitat for Andean condors and native forests, managed collaboratively by local ranchers and conservation groups.",
    image: "https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=800&q=80",
    threats: "Land use change, wildfires",
    conservation_status: "Community reserve"
  },
  {
    id: 4,
    name: "Kidepo Community Wildlife Area",
    location: "Karamoja, Uganda",
    coordinates: { lat: 3.8221, lng: 33.8698 },
    area: "850 hectares",
    biodiversity: "Elephants, lions, buffaloes, diverse savanna ecosystem",
    community: "Karamojong pastoralist communities",
    description: "Traditional grazing lands that serve as critical wildlife corridors, managed by pastoralist communities using indigenous knowledge systems.",
    image: "https://images.unsplash.com/photo-1516426122078-c23e76319801?w=800&q=80",
    threats: "Poaching, human-wildlife conflict",
    conservation_status: "Community wildlife area"
  },
  {
    id: 5,
    name: "Tagal Fisheries Reserve",
    location: "Sabah, Malaysia",
    coordinates: { lat: 5.9788, lng: 116.0753 },
    area: "12 km river stretch",
    established: "1998",
    biodiversity: "Freshwater fish species, riverine ecosystems, endemic species",
    community: "Kadazan-Dusun communities",
    description: "Community-managed fisheries using traditional 'tagal' system, combining sustainable fishing with eco-tourism for community benefit.",
    image: "https://images.unsplash.com/photo-1559827260-dc66d52bef19?w=800&q=80",
    threats: "Upstream pollution, overfishing pressure",
    conservation_status: "Community fisheries reserve"
  },
  {
    id: 6,
    name: "Shouf Biosphere Reserve",
    location: "Mount Lebanon, Lebanon",
    coordinates: { lat: 33.6891, lng: 35.6815 },
    area: "50,000 hectares",
    established: "1996",
    biodiversity: "Cedar forests, 500+ plant species, 200+ bird species, wolves, wild boar",
    community: "Mountain villages cooperative",
    description: "Lebanon's largest nature reserve protecting ancient cedar forests, managed through partnership between local communities and conservation organizations.",
    image: "https://images.unsplash.com/photo-1448375240586-882707db888b?w=800&q=80",
    threats: "Forest fires, urban expansion",
    conservation_status: "UNESCO Biosphere Reserve"
  },
  {
    id: 7,
    name: "Ilinniusiorfik Community Area",
    location: "Greenland",
    coordinates: { lat: 66.9619, lng: -53.6538 },
    area: "2,400 hectares",
    established: "2007",
    biodiversity: "Arctic char, seals, Arctic flora, seabird colonies",
    community: "Inuit communities",
    description: "Traditional Inuit hunting and fishing grounds managed according to indigenous knowledge and sustainable use principles in the Arctic region.",
    image: "https://images.unsplash.com/photo-1483683804023-6ccdb62f86ef?w=800&q=80",
    threats: "Climate change, ice melt",
    conservation_status: "Community conserved"
  },
  {
    id: 8,
    name: "Dhimurru Indigenous Protected Area",
    location: "Northern Territory, Australia",
    coordinates: { lat: -12.2464, lng: 136.8825 },
    area: "55,000 hectares",
    established: "1992",
    biodiversity: "Coastal ecosystems, marine turtles, dugongs, tropical woodlands",
    community: "Yolngu Aboriginal people",
    description: "One of Australia's first Indigenous Protected Areas, managed by Yolngu people combining traditional law with contemporary conservation practices.",
    image: "https://images.unsplash.com/photo-1523961131990-5ea7c61b2107?w=800&q=80",
    threats: "Marine debris, invasive species",
    conservation_status: "Indigenous Protected Area"
  }
];

export const articles = [
  {
    id: 1,
    title: "The Role of Indigenous Communities in Global Conservation",
    author: "Dr. Maria Santos",
    date: "2024-12-10",
    category: "Conservation",
    excerpt: "Indigenous peoples manage or have tenure rights over at least 38 million square kilometers across 87 countries, representing over a quarter of the world's land surface.",
    content: "Full article content here...",
    image: "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?w=600&q=80",
    readTime: "8 min read"
  },
  {
    id: 2,
    title: "Community Conserved Areas: A Model for Sustainable Development",
    author: "Prof. James Omondi",
    date: "2024-12-05",
    category: "Sustainability",
    excerpt: "Exploring how CCAs integrate biodiversity conservation with community livelihoods, offering lessons for sustainable development worldwide.",
    content: "Full article content here...",
    image: "https://images.unsplash.com/photo-1497436072909-60f360e1d4b1?w=600&q=80",
    readTime: "10 min read"
  },
  {
    id: 3,
    title: "Traditional Ecological Knowledge in Modern Conservation",
    author: "Dr. Lakshmi Patel",
    date: "2024-11-28",
    category: "Indigenous Knowledge",
    excerpt: "How centuries-old practices and knowledge systems are being recognized as vital tools in addressing contemporary environmental challenges.",
    content: "Full article content here...",
    image: "https://images.unsplash.com/photo-1470071459604-3b5ec3a7fe05?w=600&q=80",
    readTime: "7 min read"
  },
  {
    id: 4,
    title: "Mapping Community Conservation Success Stories",
    author: "Sarah Chen",
    date: "2024-11-20",
    category: "Research",
    excerpt: "A comprehensive study reveals that community-managed areas show biodiversity outcomes comparable to government-managed protected areas.",
    content: "Full article content here...",
    image: "https://images.unsplash.com/photo-1551522435-a13afa10f103?w=600&q=80",
    readTime: "12 min read"
  },
  {
    id: 5,
    title: "Climate Change and Community Resilience",
    author: "Dr. Ahmed Hassan",
    date: "2024-11-15",
    category: "Climate",
    excerpt: "Community conserved areas are proving to be crucial buffers against climate change impacts while maintaining cultural heritage.",
    content: "Full article content here...",
    image: "https://images.unsplash.com/photo-1569163139394-de4798aa62b6?w=600&q=80",
    readTime: "9 min read"
  },
  {
    id: 6,
    title: "Legal Recognition of Community Conservation Rights",
    author: "Advocate Elena Rodriguez",
    date: "2024-11-08",
    category: "Policy",
    excerpt: "Recent legislative developments in recognizing and protecting community tenure rights over conserved territories.",
    content: "Full article content here...",
    image: "https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=600&q=80",
    readTime: "11 min read"
  }
];

export const news = [
  {
    id: 1,
    title: "Global Fund Announces $50M for Community Conservation",
    date: "2024-12-18",
    source: "Conservation News Network",
    summary: "New funding initiative to support community-led conservation efforts across 15 countries in Africa, Asia, and Latin America.",
    link: "#",
    image: "https://images.unsplash.com/photo-1484480974693-6ca0a78fb36b?w=400&q=80"
  },
  {
    id: 2,
    title: "UNESCO Recognizes 12 New Community Biosphere Reserves",
    date: "2024-12-15",
    source: "UNESCO Press Release",
    summary: "International recognition for community-managed areas demonstrating excellence in balancing conservation with sustainable use.",
    link: "#",
    image: "https://images.unsplash.com/photo-1441974231531-c6227db76b6e?w=400&q=80"
  },
  {
    id: 3,
    title: "Community Rangers Report 40% Decline in Poaching",
    date: "2024-12-10",
    source: "Wildlife Protection Journal",
    summary: "Community-led patrol initiatives show significant success in protecting endangered species across African CCAs.",
    link: "#",
    image: "https://images.unsplash.com/photo-1564760055775-d63b17a55c44?w=400&q=80"
  },
  {
    id: 4,
    title: "Indigenous Communities Win Land Rights Case",
    date: "2024-12-05",
    source: "Environmental Law Review",
    summary: "Landmark court decision strengthens legal protection for community conserved territories in South America.",
    link: "#",
    image: "https://images.unsplash.com/photo-1473186578172-c141e6798cf4?w=400&q=80"
  }
];

export const resources = [
  {
    id: 1,
    title: "Community Conservation Toolkit",
    type: "Guide",
    description: "Comprehensive guide for establishing and managing community conserved areas, including legal frameworks and best practices.",
    downloadLink: "#",
    icon: "BookOpen"
  },
  {
    id: 2,
    title: "Biodiversity Monitoring Methods",
    type: "Manual",
    description: "Step-by-step instructions for community-based biodiversity assessment and monitoring programs.",
    downloadLink: "#",
    icon: "Microscope"
  },
  {
    id: 3,
    title: "Traditional Knowledge Documentation",
    type: "Template",
    description: "Templates and protocols for documenting and preserving traditional ecological knowledge systems.",
    downloadLink: "#",
    icon: "FileText"
  },
  {
    id: 4,
    title: "Sustainable Tourism Development",
    type: "Case Studies",
    description: "Success stories and frameworks for developing eco-tourism in community conserved areas.",
    downloadLink: "#",
    icon: "Map"
  },
  {
    id: 5,
    title: "Funding Opportunities Database",
    type: "Directory",
    description: "Updated list of grants, funds, and financial mechanisms supporting community conservation initiatives.",
    downloadLink: "#",
    icon: "DollarSign"
  },
  {
    id: 6,
    title: "Legal Protection Strategies",
    type: "Guide",
    description: "Legal pathways for securing tenure rights and official recognition of community conserved areas.",
    downloadLink: "#",
    icon: "Scale"
  },
  {
    id: 7,
    title: "Climate Adaptation Planning",
    type: "Workshop Materials",
    description: "Resources for communities to develop climate change adaptation strategies for their conserved areas.",
    downloadLink: "#",
    icon: "CloudRain"
  },
  {
    id: 8,
    title: "Conflict Resolution Framework",
    type: "Guide",
    description: "Tools for addressing human-wildlife conflict and resource use disputes in community-managed areas.",
    downloadLink: "#",
    icon: "Users"
  }
];

export const stats = {
  totalCCAs: "15,000+",
  areasProtected: "2.3M km²",
  communitiesInvolved: "370M people",
  countriesRepresented: "87 countries"
};
